import { useTranslation } from 'next-i18next'
import userApi from 'src/api/userApi'
import useGetWithContext from 'src/hooks/useGetWithContext'

export const TeacherCharacteristic = ({ teacherId }) => {
  const { data } = useGetWithContext(`GET_USER_BY_ID_${teacherId}`, userApi.detail, teacherId, { isDisabled: !teacherId })
  if (!data) return null
  return <span>{data?.userInfoData?.find(item => item.field?.shortName === 'note')?.data || null}</span>
}

export const TeacherCertificate = ({ teacherId }) => {
  const { t } = useTranslation()
  const { data } = useGetWithContext(`GET_USER_BY_ID_${teacherId}`, userApi.detail, teacherId, { isDisabled: !teacherId })
  if (!data) return null
  const certificate = data.userInfoData?.find(item => item.field?.shortName === 'certificate')?.data
  const certificateNote = data.userInfoData?.find(item => item.field?.shortName === 'certificateNote')?.data
  return <span>{certificate && t(`constant.certificate.${certificate}`) + ` ${certificateNote || ''}`}</span>
}
